import { useEffect, useRef, useState } from "react";

export const DELETE_KEY_EASTER_EGG_PRESS_COUNT = 5;
export const DELETE_KEY_EASTER_EGG_WINDOW_MS = 1200;

/**
 * Reveal hidden admin tools after pressing Delete 5 times quickly (outside inputs).
 */
export function useDeleteKeyEasterEgg() {
  const [showEasterEgg, setShowEasterEgg] = useState(false);
  const pressRef = useRef({ count: 0, lastAt: 0 });

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key !== "Delete") return;
      const tag = e.target?.tagName;
      if (
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        tag === "SELECT" ||
        e.target?.isContentEditable
      ) {
        return;
      }

      const now = Date.now();
      const { count, lastAt } = pressRef.current;
      const withinWindow = now - lastAt <= DELETE_KEY_EASTER_EGG_WINDOW_MS;
      const nextCount = withinWindow ? count + 1 : 1;
      pressRef.current = { count: nextCount, lastAt: now };

      if (nextCount >= DELETE_KEY_EASTER_EGG_PRESS_COUNT) {
        setShowEasterEgg(true);
        pressRef.current = { count: 0, lastAt: 0 };
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return { showEasterEgg, setShowEasterEgg };
}
